<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>疗养预约系统</el-breadcrumb-item>
        <el-breadcrumb-item>疗养信息</el-breadcrumb-item>
        <el-breadcrumb-item>信息发布</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow" id="convalescenceAdd">
      <el-form v-loading="formLoading" v-model="listParams">
        <el-form-item label="疗养申请提交时间段：" style="width: 100%">
          <date-picker-group v-model="listParams.tempApplyTime" style="width: 400px"></date-picker-group>
        </el-form-item>

        <el-form-item label="疗养时间段：">
          <date-picker-group v-model="listParams.tempConvalescenceTime" style="width: 400px"></date-picker-group>
        </el-form-item>

        <el-form-item label="疗养地点：">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" v-on:change="handleCheckAllChange">全选</el-checkbox>
          <div style="margin: 15px 0"></div>
          <el-checkbox-group v-model="checkedCities" v-on:change="handleCheckedCitiesChange">
            <el-checkbox v-for="item in convalescenceAddressList" :label="item.id" :key="item.id">{{ item.name }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item class="align-center mgt10" style="padding-bottom: 20px; margin-top: 20px">
          <el-button size="small" type="primary" v-on:click="saveAdd()"> 发布疗养信息 </el-button>
          <el-button size="small" class="mgl20" v-on:click="backToList">返回</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formLoading: false,
      listParams: [],
      checkAll: false,
      convalescenceAddressList: [],
      convalescenceAddressKey: [],
      checkedCities: [],
      isIndeterminate: true,
    };
  },
  created() {},
  mounted() {
    this.loadConvalescenceList();
  },
  methods: {
    loadConvalescenceList: function () {
      const bodyParams = Object.assign(
        {},
        {
          page: 1,
          size: 100,
        }
      );
      this.$http({
        url: global.apiUrl + "/recuperate/address/list",
        methods: "GET",
        params: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.formLoading = false;
            this.convalescenceAddressList = res.body.data.data;
            const arr = [];
            for (const i in this.convalescenceAddressList) {
              arr.push(this.convalescenceAddressList[i].id);
            }
            this.convalescenceAddressKey = arr;
          } else {
            this.formLoading = false;
          }
        })
        .catch(err => {
          this.formLoading = false;

          console.error(err);
        });
    },
    saveAdd: function () {
      this.tableLoading = true;
      let tempIdList = "";
      let tempTitleList = "";
      for (const i in this.checkedCities) {
        tempIdList += this.checkedCities[i] + ",";
        for (const j in this.convalescenceAddressList) {
          if (this.checkedCities[i] == this.convalescenceAddressList[j].id) {
            tempTitleList += this.convalescenceAddressList[j].name + ",";
          }
        }
      }
      tempIdList = tempIdList.replace(/(^,*)|(,*$)/g, "");
      tempTitleList = tempTitleList.replace(/(^,*)|(,*$)/g, "");
      this.listParams.addressId = tempIdList;
      this.listParams.address = tempTitleList;
      const bodyParams = Object.assign(
        {},
        {
          applyStartTime: this.listParams.tempApplyTime[0],
          applyEndTime: this.listParams.tempApplyTime[1],
          recuperateStartTime: this.listParams.tempConvalescenceTime[0],
          recuperateEndTime: this.listParams.tempConvalescenceTime[1],
          addressId: this.listParams.addressId,
          address: this.listParams.address,
        }
      );
      this.$http({
        url: global.apiUrl + "/recuperate/publishRecuperate",
        method: "POST",
        params: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.$message({
                message: res.body.info,
                type: "success",
              });
              this.$router.push({
                name: "convalescenceInfo",
              });
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    handleCheckAllChange(val) {
      this.checkedCities = val ? this.convalescenceAddressKey : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      const checkedCount = value.length;
      this.checkAll = checkedCount === this.convalescenceAddressList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.convalescenceAddressList.length;
    },
    backToList: function () {
      this.$router.push({
        name: "convalescenceInfo",
      });
    },
  },
};
</script>

<style lang="less" scoped>
.el-checkbox-group {
  width: 625px;
}
.el-checkbox:nth-child(5n + 1) {
  margin-left: 0;
}
#convalescenceAdd .el-form-item__label {
  float: none;
}
</style>
